/*!
 * ORDER/Voucher.Strategies
 *
 * @author Andrew Hill
 */
module.exports = {
    PERCENT: function(){
        this.calculate = function(order, voucher){
            var discountableAmount = order.getDiscountableCost();

            if(voucher.hasMinSpendValue(discountableAmount, voucher)){
                return discountableAmount * parseFloat(voucher.voucher.amt);
            }

            return 0;
        };
    },

    FIXED: function(){
        this.calculate = function(order, voucher){
            var discountableAmount = order.getDiscountableCost();

            if(voucher.hasMinSpendValue(discountableAmount, voucher)){
                return parseFloat(voucher.voucher.amt);
            }

            return 0;
        };
    },

    FREESET: function(){
        this.calculate = function(order, voucher){
            if(order.isCopiesOrdered()){
                var sets = 0;

                if(order.getNumberOfTapes() == 0){
                    voucher.errors.push({ message: "This voucher requires you to order some tapes, then you will get the voucher's free copies."});
                    return;
                }

                //Sets
                if($("#copy_copy_set").is(":checked")) {
                    //Number of "sets"
                    sets = this.setsToDiscount("copy_set", voucher.voucher.amt);
                    orderedSets = $('#qty_copy_set').val();
                    if(voucher.hasMinItemsValue(orderedSets, voucher, "copy sets")){
                        return ORDER.Options.copy.copy_set.cost * order.getNumberOfTapes() * sets;
                    }
                } else
                //Individual DVDs
                if($("#copy_copy_dvd").is(":checked")){
                    sets = this.setsToDiscount("copy_dvd", voucher.voucher.amt);
                    orderedSets = $('#qty_copy_dvd').val();
                    if(voucher.hasMinItemsValue(orderedSets, voucher, "copy sets")){
                        return ORDER.Options.copy.copy_set.cost * sets;
                    }
                }
            } else {
                voucher.errors.push({ message: "This voucher requires you to order at least " + voucher.voucher.min_order + " sets of copies, then you will get the voucher's free copies."});
            }
        };

        this.setsToDiscount = function(copyType, voucherAmt){
            var sets = $('#qty_' + copyType).val();
            var setsToDiscount = parseInt(voucherAmt);

            if(sets >= setsToDiscount){
                sets = setsToDiscount;
            }

            return sets;
        }
    }
};